import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { DialogActions } from "@material-ui/core";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import TicketsService from "Services/http/endpoints/tickets/TicketsService";
import StatusHandler from "Helpers/StatusHandler";
import MuiUpload from "Components/MuiUpload/MuiUpload";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { GETAGAINTICKET } from "Stores/actionTypes";

function AddUser({ ...props }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    title: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: 12,
    },
    ticketGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: 12,
    },
    description: {
      type: "text",
      value: "",
      col: 12,
    },
    checkbox: {
      type: "checkbox",
      items: [
        { value: false, label: t('onReplySMS'), key: "isNotifyResponseSms" },
      ],
      col: 12,
    },
  });
  const [selectedFile, setSelectedFile] = React.useState(null);

  const onClear = () => {
    setFormValid({});
    setControls({ title: { value: "" } });
    setControls({ description: { value: "" } });
    setSelectedFile(null)
  };

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { title, description, ticketGroup, checkbox } = controls;
      try {
        let bodyFormData = new FormData();
        bodyFormData.append("KeyGroup", read("groupKey"));
        bodyFormData.append("KeyUser", read("userKey"));
        bodyFormData.append("Title", title.value);
        bodyFormData.append("Description", description.value);
        bodyFormData.append("GroupTicketId", ticketGroup.value.value);
        bodyFormData.append("IsNotifyResponseSms",checkbox.items[0].value);
        bodyFormData.append("Attachment", selectedFile);
        bodyFormData.append("SIdForm", 0);
        bodyFormData.append("SAction", 0);

        const response = await TicketsService.postTicket(bodyFormData);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({ text: t('mission_accomplished'),  customClass: "success"});
        }
        dispatch({ type: GETAGAINTICKET, data: true });
        handleDialog();
        onClear();
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
      handleDialog();
    } else {
      showNotify({
        text: t('correctFormDataRequired'),
        customClass: "error",
      });
    }
  };

  const onChangeFile = ({target}) => {
    setSelectedFile(target.files[0]);
  }
  const onDeleteFile = () => {
    setSelectedFile(null);
  }

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        SIdForm: 0,
        SAction: 0,
      };
      const response = await TicketsService.getTicketGroups(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const updateList = response.data.Value.map((item) => {
          return {
            ...item,
            label: item.Name,
            value: item.Id,
          };
        });
        setControls({ ticketGroup: { selectItems: updateList } });
        if (updateList.length > 0) {
          setControls({ ticketGroup: { value: updateList[0] } });
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id="newTicket" />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{t('createNewTicket')}</p>
          </div>
          <DialogContent  className="mt-2">
            {!loading ? (
              <Grid container>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid item xs={controls[key].col ? controls[key].col : 6} key={key + index}>
                      {controls[key].type === "text" && (
                        <Input
                          loading={props.loading}
                          value={controls[key].value}
                          setValue={setValue.bind(this)}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type="text"
                          readOnly={controls[key].readOnly}
                          multiline={key === "description" ? true : false}
                          rows={key === "description" ? 3 : 1}
                        />
                      )}
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          loading={loading}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      )}
                      {controls[key].type === "checkbox" && (
                        <MuiCheckBoxGroup
                          name={key}
                          value={controls[key].value}
                          items={controls[key].items}
                          onChange={onChangeCheckbox}
                          className="horizontalCheckbox"
                        />
                      )}
                    </Grid>
                  );
                })}
                <Grid item xs={12} className="mt-4">
                  <MuiUpload
                    onChange={onChangeFile}
                    selectedFile={selectedFile}
                    onDeleteFile={onDeleteFile}
                  />
                </Grid>
              </Grid>
            ) : (
              <MuiSkeleton xs={4} number={12} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default AddUser;
